<template>
  <div class="complaint-list">
    <p class="title">申诉表单展示</p>
    <el-table
      v-loading="loading"
      :data="complaintList"
      style="width:100%">
      <el-table-column
        prop="feedback_name"
        label="主张人主体名称"
      />
      <el-table-column
        prop="feedback_phone"
        label="移动电话"
      />
      <el-table-column
        prop="feedback_contact"
        label="其他联系方式"
      />
      <el-table-column
        prop="feedback_appeal"
        label="主张诉求"
      />
      <el-table-column
        prop="id"
        label="查看详情"
      >
        <template slot-scope="{row}">
          <el-link type="primary" @click="jumpToDetails(row.id)">查看详情</el-link>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      :total="total"
      layout="prev, pager, next"
      :page-size="pageSize"
      :current-page="currentPage"
      @next-click="nextClick(currentPage)"
      @pre-click="preClick(currentPage)"
      class="pagination"
    />
  </div>
</template>

<script>
import axios from 'axios'
// axios.defaults.withCredentials = true

export default {
  name: 'complaintList',
  data() {
    return {
      loading: true,
      currentPage: 0,
      pageSize: 20,
      total: 20,
      complaintList: []
    }
  },
  methods: {
    initData(currentPage) {
      axios.get(`/cfapi/v1/cms/feedback?limit=${this.pageSize}&offset=${currentPage}`).then((res) =>{
        this.complaintList = res.data.data.feedbacks
        this.total = res.data.data.total
      })
    },
    initLogin() {
      if(this.$route.query.uacLoginToken){
        axios.post('/cfapi/v1/cms/uac/login', {'uacLoginToken': this.$route.query.uacLoginToken })
        .then(() => {
          this.initData(this.currentPage)
          this.loading = false
        })
      }else {
        window.location.href= 'http://uac.dailyinnovation.biz?next=' + encodeURIComponent(window.location.href)
      }
    },
    jumpToDetails(id) {
      this.$router.push(`/complaintDetails?feedback_id=${id}`)
    },
    preClick(currentPage) {
      if(this.currentPage > 0){
        this.currentPage--
        this.initData(currentPage)
      }
    },
    nextClick(currentPage) {
      this.currentPage++
      this.initData(currentPage)
    }
  },
  mounted() {
    this.initLogin()
  }
}
</script>
<style scoped>
.complaint-list{
  padding:60px 50px;
  text-align: center;
}
.pagination{
  margin-top:20px;
}
.title{
  font-size:30px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/ComplaintList.vue